import React, { useState, useEffect, useRef  } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios'; 
import API_URL from '../api/config';
import { useQuery } from '@tanstack/react-query';
import '../styles/style.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import { toast, ToastContainer } from 'react-toastify';
import ImageWithLoader2 from '../components/ImageWithLoader2';
import ReactModal from 'react-modal';

const Sidebar = (props) => {

  const [showAccountMenu, setShowAccountMenu] = useState(false);
  const [showActivityModal, setShowActivityModal] = useState(false);
  const [showUpgradeModal, setShowUpgradeModal] = useState(false);
  const ACTIVITY_FEATURE_ENABLED = true;

    
    const navigate = useNavigate();


  {/**
    
    const [isSideMenu, setSideMenu] = useState("")

	const toggleSidebar = (value) => {
		//console.log (value);
		setSideMenu(value)
		
	}
    */}

  const [openMenu, setOpenMenu] = useState(null);

  const toggleMenu = (menu) => {
    setOpenMenu(openMenu === menu ? null : menu);
  };

  
     // Fetch User Details
    const { data: user, isLoadingP, isErrorP } = useQuery({
      queryKey: ['userDetails'],
      queryFn: () =>
        axios.get(`${API_URL}/user-details-api`, { withCredentials: true })
          .then(res => res.data),
      staleTime: 0,
      cacheTime: Infinity,
    });


    const handleLogout = async () => {
      try {
        const res = await axios.post(`${API_URL}/logout`, {}, { withCredentials: true });
  
        if (res.data.Status === "Success") {
          // Clear any stored tokens/session data
          localStorage.removeItem("token");
          sessionStorage.clear();
  
          toast.success("Logged out successfully");
          navigate("/"); // redirect to login page
        } else {
          toast.error(res.data.message || "Logout failed");
        }
      } catch (err) {
        console.error(err);
        toast.error("Server error during logout");
      }
    };



     const [websiteModalOpen, setWebsiteModalOpen] = useState(false);
      const [loadingWebsite, setLoadingWebsite] = useState(true);
    
    
      const [termsModalOpen, setTermsModalOpen] = useState(false);
      const [loadingTerms, setLoadingTerms] = useState(true);
             
      const [privacyModalOpen, setPrivacyModalOpen] = useState(false);
      const [loadingPrivacy, setLoadingPrivacy] = useState(true);

      const sidebarRef = useRef(null);
      useEffect(() => {
        const handleClickOutside = (event) => {
          if (
            window.innerWidth <= 768 && // mobile only
            sidebarRef.current &&
            !sidebarRef.current.contains(event.target)
          ) {
            document.getElementById("sidebar").classList.remove("open-sidebar");
          }
        };
      
        document.addEventListener("mousedown", handleClickOutside);
      
        return () => {
          document.removeEventListener("mousedown", handleClickOutside);
        };
      }, []);

 
  return (
    <div className="sidebar" id="sidebar"  ref={sidebarRef}>
					<div className="sidebar-inner slimscroll">

            <ToastContainer />


            <div className="text-center text-white py-2 border-bottomx bg-whitex">
            {isLoadingP ? (
              <p>Loading user...</p>
            ) : isErrorP ? (
              <p>Error loading user</p>
            ) : (
              <div className="d-flex flex-column align-items-center">
                <ImageWithLoader2
                  className="rounded-circle shadow"
                  src={user?.image_file_final}
                  placeholder="https://oret.africa/tree/img/placeholder-human-icon.jpg"
                  fadeDuration={800}
                  blurAmount={15}
                  alt="Profile"
                  style={{
                    width: '72px',
                    height: '72px',
                    objectFit: 'cover',
                    border: '3px solid #75B437',
                    boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                  }}
                />
                <div className="mt-2 fw-bold">
                  {user?.n_prefix} {user?.name} {user?.last_name}
                </div>
              </div>
            )}
          </div>


            <div className="px-3 pt-3 text-white">
                      <div
                        className="d-flex justify-content-between align-items-center nav-link  "
                        style={{ cursor: 'pointer' }}
                        onClick={() => setShowAccountMenu(!showAccountMenu)}
                      >
                        <span><i className="bi bi-person   me-2"></i> Account</span>
                        <i className={`bi ${showAccountMenu ? 'bi-chevron-up' : 'bi-chevron-right'}  text-white`}></i>
                      </div>
                      {showAccountMenu && (
                        <ul className="nav flex-column mt-2 ms-3">
                          <li className="nav-item mb-1">
            
                          <button  className="nav-link  text-white small"
                                     onClick={() => navigate('/profile', { state: {memberId: user?.id } })}
                                    >
                                    <i className="bi bi-person me-2"></i> Profile</button>
                          </li>
                          <li className="nav-item mb-1">
                            <Link to="/profile-settings" className="nav-link  text-white small">
                              <i className="bi bi-gear me-2"></i> Settings
                            </Link>
                          </li>
                           
                        </ul>
                      )}
                    </div>
                      

           


          <hr className="mx-3x" style={{color: '#ffff'}} />

        <div id="sidebar-menu" className="sidebar-menu" style={{ height: "50vh", overflowY: "auto", overflowX: "hidden" }}>

          <ul>

          


          <li className={`submenu ${openMenu === 'Dashboard' ? 'active' : ''}`}>
            <Link to={"/home"}> <i class="fas fa-th-large"></i>  <span>Home</span>  <span className="menu-arrow"></span> </Link>
          </li>

          <li className={`submenu ${openMenu === 'FamilyTree' ? 'active' : ''}`}>
            <Link to={"/family-tree"}> <i class="fas fa-sitemap"> </i>  <span>Family Tree</span>  <span className="menu-arrow"></span> </Link>
          </li>

          
          <li className={`submenu ${openMenu === 'SearchPeople' ? 'active' : ''}`}>
            <Link to={"/search-people"}> <i class="fas fa-search"> </i>  <span>Search People</span>  <span className="menu-arrow"></span> </Link>
          </li>

          <li className={`submenu ${openMenu === 'Search' ? 'active' : ''}`}>
            <Link to={"/search-family"}> <i class="fas fa-search-plus"> </i>  <span>Search Family</span>  <span className="menu-arrow"></span> </Link>
          </li>


          <li className={`submenu ${openMenu === 'FamilyPage' ? 'active' : ''}`}>
            <Link to={"/family-settings"}> <i class="fas fa-file"> </i>  <span>Family Page</span>  <span className="menu-arrow"></span> </Link>
          </li>

            <li className={`submenu ${openMenu === 'members' ? 'active' : ''}`}>
              <a href="#!" onClick={() => toggleMenu('members')}  >
                <i className="fas fa-users"></i> <span> Members</span> <span className="menu-arrow"></span>
              </a>
              {openMenu === 'members' && (
                <ul>
                  <li><Link to="/family-members">Members</Link></li>
                  <li><Link to="/family-members-deceased"  >In Loving Memory</Link></li>
                </ul>
              )}
            </li>

            <li className={`submenu ${openMenu === 'Chat' ? 'active' : ''}`}>
            <Link to={"/chat-list"}> <i class="fas fa-comment"> </i>  <span>Chat</span>  <span className="menu-arrow"></span> </Link>
          </li>

          <li className={`submenu ${openMenu === 'Gallery' ? 'active' : ''}`}>
            <Link to={"/gallery"}> <i class="fas fa-image"> </i>  <span>Gallery</span>  <span className="menu-arrow"></span> </Link>
          </li>

          <li className={`submenu ${openMenu === 'FamilyEvents' ? 'active' : ''}`}>
            <Link to={"/family-events"}> <i class="fas fa-calendar"> </i>  <span>Family Events</span>  <span className="menu-arrow"></span> </Link>
          </li>

          <li className={`submenu ${openMenu === 'Timeline' ? 'active' : ''}`}>
            <Link to={"/timeline"}> <i class="bi bi-clock-history"> </i>  <span>Timeline</span>  <span className="menu-arrow"></span> </Link>
          </li>


          
          <hr className="mx-3x " style={{color: '#ffff'}} />

                   
              <li className="nav-item mb-2">
                <Link to="/need-help" className="nav-link text-darkx">
                  <i className="bi bi-question-circle me-2 text-success"></i> Need Help?
                </Link>
              </li>
              <li className="nav-item mb-2">
              <Link to="https://oret.africa/" className="nav-link text-darkx" target='_blank'>
                  <i className="bi bi-globe me-2 text-success"></i> Our Website
                </Link>
              </li>
              <li className="nav-item mb-2">
                <Link onClick={() => setPrivacyModalOpen(true)} className="nav-link text-darkx">
                  <i className="bi bi-shield-lock me-2 text-success"></i> Privacy
                </Link>
              </li>
              <li className="nav-item mb-2">
                <Link onClick={() => setTermsModalOpen(true)} className="nav-link text-darkx">
                  <i className="bi bi-file-earmark-text me-2 text-success"></i> Terms
                </Link>
              </li>
              {/*<li className="nav-item mb-2">
                <Link to="/report-concern" className="nav-link text-darkx">
                  <i className="fas fa-exclamation-circle me-2 text-success"></i> Report a Concern
                </Link>
              </li>*/}
             
  
          </ul>
          

          
        </div>


            <ReactModal
                            isOpen={websiteModalOpen}
                            onRequestClose={() => setWebsiteModalOpen(false)}
                            className="Modal modal-lg"
                            overlayClassName="Overlay" style={{
                              overlay: { zIndex: 10000, backgroundColor: "rgba(0,0,0,0.5)" },
                              content: { zIndex: 10001 }
                            }}
                          >
                            <div className="modal-header">
                              <h5 className="modal-title">Oret Africa</h5>
                              <button
                                type="button"
                                className="btn-close modalCloseButton"
                                onClick={() => setWebsiteModalOpen(false)}
                              ></button>
                            </div>
                      
                            <div
                              className="modal-body p-0 position-relative"
                              style={{ maxHeight: "60vh", overflow: "hidden" }}
                            >
                              {loadingTerms && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "0",
                                    left: "0",
                                    right: "0",
                                    bottom: "0",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: "rgba(255,255,255,0.8)",
                                    zIndex: 10,
                                  }}
                                >
                                  <div className="spinner-border text-primaryx" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                  </div>
                                </div>
                              )}
                      
                              <iframe
                                src="https://oret.africa/"
                                title="Terms of Use"
                                style={{ width: "100%", height: "80vh", border: "none" }}
                                onLoad={() => setLoadingWebsite(false)}
                              ></iframe>
                            </div>
                      
                            <div className="modal-footer"></div>
                          </ReactModal>
                      
        
                      
                                              
                            <ReactModal
                            isOpen={termsModalOpen}
                            onRequestClose={() => setTermsModalOpen(false)}
                            className="Modal modal-lg"
                            overlayClassName="Overlay" style={{
                              overlay: { zIndex: 10000, backgroundColor: "rgba(0,0,0,0.5)" },
                              content: { zIndex: 10001 }
                            }}
                          >
                            <div className="modal-header">
                              <h5 className="modal-title">Terms of Use</h5>
                              <button
                                type="button"
                                className="btn-close modalCloseButton"
                                onClick={() => setTermsModalOpen(false)}
                              ></button>
                            </div>
                      
                            <div
                              className="modal-body p-0 position-relative"
                              style={{ maxHeight: "60vh", overflow: "hidden" }}
                            >
                              {loadingTerms && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "0",
                                    left: "0",
                                    right: "0",
                                    bottom: "0",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: "rgba(255,255,255,0.8)",
                                    zIndex: 10,
                                  }}
                                >
                                  <div className="spinner-border text-primaryx" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                  </div>
                                </div>
                              )}
                      
                              <iframe
                                src="https://oret.africa/terms-and-conditions/"
                                title="Terms of Use"
                                style={{ width: "100%", height: "80vh", border: "none" }}
                                onLoad={() => setLoadingTerms(false)}
                              ></iframe>
                            </div>
                      
                            <div className="modal-footer"></div>
                          </ReactModal>
                      
                      
                      
                      
                      
                          <ReactModal
                            isOpen={privacyModalOpen}
                            onRequestClose={() => setPrivacyModalOpen(false)}
                            className="Modal modal-lg"
                            overlayClassName="Overlay"  style={{
                              overlay: { zIndex: 10000, backgroundColor: "rgba(0,0,0,0.5)" },
                              content: { zIndex: 10001 }
                            }}
                          >
                            <div className="modal-header">
                              <h5 className="modal-title">Privacy Policy</h5>
                              <button
                                type="button"
                                className="btn-close modalCloseButton"
                                onClick={() => setPrivacyModalOpen(false)}
                              ></button>
                            </div>
                      
                            <div
                              className="modal-body p-0 position-relative"
                              style={{ maxHeight: "60vh", overflow: "hidden" }}
                            >
                              {loadingPrivacy && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "0",
                                    left: "0",
                                    right: "0",
                                    bottom: "0",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    background: "rgba(255,255,255,0.8)",
                                    zIndex: 10,
                                  }}
                                >
                                  <div className="spinner-border text-primaryx" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                  </div>
                                </div>
                              )}
                      
                              <iframe
                                src="https://oret.africa/privacy-policy/"
                                title="Privacy Policy"
                                style={{ width: "100%", height: "80vh", border: "none" }}
                                onLoad={() => setLoadingPrivacy(false)}
                              ></iframe>
                            </div>
                      
                            <div className="modal-footer"></div>
                          </ReactModal>
        


         
       

        <div className="p-3 border-top small text-mutedx sidebar-footer">
          <ul className="nav flex-column mb-2">
            <li className="nav-item">
              

              <button
                onClick={handleLogout}
                className="nav-link text-white"
                style={{ border: "none", background: "none", cursor: "pointer" }}
              >
                <i className="bi bi-box-arrow-right me-2 text-danger"></i> Logout
              </button>

            </li>
          </ul>
          <div className='text-white'>
            Logged in as <strong>{user?.n_prefix} {user?.name} {user?.last_name}</strong>
          </div>
        </div>



      </div>
      </div>
  );
}

export default Sidebar;
